import { Component, OnInit, ViewChild }              from '@angular/core';
import { Inject}                                     from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA}   from '@angular/material';
import { MatSnackBar }                               from '@angular/material';

import { TdDialogService }                           from '@covalent/core';
import { ViewContainerRef }                          from '@angular/core';

import {FormControl}                                 from '@angular/forms';
import {Observable}                                  from 'rxjs';

import { AppService }                                from '../../../../../core/service/app.service';

import { License }                                   from '../../../vo/license';
import { LicenseService }                            from '../../../service/license.service';

/**
 * License Popup Sync Now Component
 * 
 * This component is used to ask if we need to sync information now or not
 */
@Component(
{
    selector: 'license-popup-sync-now-component',
    templateUrl: 'license.popup.sync.now.component.html',
    styleUrls: [ 'license.popup.sync.now.component.css']
})
export class LicensePopupSyncNowComponent implements OnInit
{
    /**
     * Constructor
     * 
     */
	constructor
	(
		private dialogRef: MatDialogRef<LicensePopupSyncNowComponent>,
        private _dialogService: TdDialogService,
        private licenseService:LicenseService,
        private _viewContainerRef: ViewContainerRef,
        private snackBar: MatSnackBar,
        /**
        * Access to the Main App Service
        */
        public appService: AppService, 
        private dialog: MatDialog,
        /**
        * Datas pass to the component
        */
		@Inject(MAT_DIALOG_DATA) public data: any
	) 
    {
    }

    /**
    * Index for the Loading component
    */
    public index_loading:number;


    /*****************************************************************/
    //
    // Initialisation
    //
    /*****************************************************************/

    /**
     * Initialisation
     * 
     */
    ngOnInit(): void 
    {
       
    }


    /*****************************************************************/
    //
    // Dialog
    //
    /*****************************************************************/

    /**
     * Open an alert message
     * 
     * @param {string} Content of the message
     * @param {string} Title of the message
     * @param {string} Label of the close button
     */
    public openDialog( content:string, title:string, closeButton:string )
    {
        this._dialogService.openAlert
        (
            {
                message: content,
                title: title, 
                closeButton: closeButton, 
            }
        );
    }


    /*****************************************************************/
    //
    // Popup
    //
    /*****************************************************************/

    /**
    * Called when the user clik outside the popup
    *
    */
    onNoClick(): void 
    {
        this.dialogRef.close();
    }

    /**
    * Close the popup
    *
    */
    public on_tomorrow():void
    {
        this.dialogRef.close();
    }

    /**
    * Ask to the system to reboot
    *
    */
    public on_now():void
    {
        this.licenseService.sync( this.data.license )
        .then
        (
            res =>
            {
                if(  res == -1)
                {
                    this.openDialog( "Fail to force update", "Error", "Close");
                }
                else
                {
                    if( res == 0 )
                    {
                        this.dialogRef.close();  
                    }
                    else
                    {
                        this.data.license.last_command_id = res;
                        this.dialogRef.close( {last_command_id:res} );  
                    }
                }      
            }
        );
    }
}

